// Change Log
export const CHANGE_LOG_TITLE = 'Change Log';
export const CHANGE_LOG_VIEW_ALL_CHANGES =
  'View all changes made to a user account by PrizePicks member operations.';

// Manage Legacy Ruleset
export const MANAGE_LEGACY_RULESET_FAIL =
  "Error: Ruleset updates couldn't be saved.  Contact Backoffice team for further assistance.";
export const MANAGE_LEGACY_RULESET_SUCCESS =
  'Ruleset has been successfully updated for this member.';
export const MANAGE_LEGACY_RULESET_TITLE = 'Manage ruleset';

// Manage Member Groups
export const MANAGE_MEMBER_GROUPS_TITLE = 'Manage member groups';
export const MANAGE_MEMBER_GROUPS_SUCCESS =
  'Groups have been successfully updated for this member.';
export const MANAGE_MEMBER_GROUPS_FAIL =
  "Error: Group updates couldn't be saved.  Contact Backoffice team for further assistance.";
export const MANAGE_MEMBER_GROUPS_NO_GROUPS =
  'This member is not assigned to a member group.';

// Reset Password
export const RESET_PASSWORD_TITLE = 'Confirm password reset';
export const RESET_PASSWORD_CONFIRMATION =
  'Are you sure you want to reset the password for this PrizePicks account?';
export const RESET_PASSWORD_EMIAL_INSTRUCTIONS =
  'An email with instructions will be sent to the member.';
export const RESET_PASSWORD_SUCCESS = 'An email has been sent to the member.';
export const RESET_PASSWORD_FAIL =
  "Error: Email couldn't been sent to the member.  Contact Backoffice team for further assistance.";

// Edit Account Information
export const EDIT_ACCOUNT_INFORMATION_TITLE = 'Edit account information';
export const EDIT_ACCOUNT_INFORMATION_SUCCESS =
  'Account information has been successfully updated for this member.';
export const EDIT_ACCOUNT_INFORMATION_FAIL =
  "Error: Account information couldn't be updated.  Contact Backoffice team for further assistance.";

// Enroll Kindbridge
export const ENROLL_KINDBRIDGE_TITLE = 'Enroll in Kindbridge';
export const ENROLL_KINDBRIDGE_CONFIRMATION =
  'Are you sure you want to enroll this member in Kindbridge?';
export const ENROLL_KINDBRIDGE_SUCCESS =
  'The member has been enrolled to Kindbridge.';
export const ENROLL_KINDBRIDGE_FAIL =
  'Error: Unable to enroll member in Kindbridge.  Contact Backoffice team for further assistance.';
export const KINDBRIDGE_NOT_ENROLLED = 'Not enrolled';

// Manage TIN Status
export const MANAGE_TIN_COLLECTION_TITLE = 'Update TIN collection status';
export const MANAGE_TIN_COLLECTION_SUCCESS =
  'TIN collection status has been updated for this member.';
export const MANAGE_TIN_COLLECTION_FAIL =
  'Error: TIN collection status could not be updated.  Contact Backoffice team for further assistance.';
export const TIN_COLLECTION_OPTIONS = [
  {
    option: 'Unvalidated (0)',
    description: 'TIN has not been specified or validated',
    value: '0'
  },
  {
    option: 'Validated (1)',
    description: 'TIN has been validated',
    value: '1'
  }
];

// Manage VIP Status
export const MANAGE_VIP_STATUS_TITLE = 'Toggle VIP status';
export const MANAGE_VIP_STATUS_MESSAGE = `Toggling VIP status for member will add or remove member to the VIP member group.`;
export const MANAGE_VIP_STATUS_SUCCESS =
  'VIP status has been updated for this member.';
export const MANAGE_VIP_STATUS_FAIL =
  'Error: VIP status could not be updated.  Contact Backoffice team for further assistance.';

// Manually Pass Member
export const MANUALLY_PASS_MEMBER_TITLE = 'Manually pass member';
export const MANUALLY_PASS_MEMBER_MESSAGE = 'This member is not verified.';
export const MANUALLY_PASS_MEMBER_SUBMESSAGE =
  'Are you sure you want to verify this member?';
export const MANUALLY_PASS_MEMBER_SUCCESS = 'The member has been verified.';
export const MANUALLY_PASS_MEMBER_FAIL =
  'Error: Member could not be verified.  Contact Backoffice team for further assistance.';

// Update Member Activation
export const DEACTIVATE_MEMBER_TITLE = 'Deactivate member';
export const DEACTIVATE_MEMBER_SUCCESS = 'The member has been deactivated.';
export const DEACTIVATE_MEMBER_FAIL =
  'Error: Member could not be deactivated.  Contact Backoffice team for further assistance.';
export const REACTIVATE_MEMBER_TITLE = 'Reactivate member';
export const REACTIVATE_MEMBER_MESSAGE =
  'Are you sure you want to reactivate this member?';
export const REACTIVATE_MEMBER_SUCCESS = 'The member has been reactivated.';
export const REACTIVATE_MEMBER_FAIL =
  'Error: Member could not be reactivated.  Contact Backoffice team for further assistance.';
export const activationMessage = (isDeactivated: boolean) => {
  return {
    content: isDeactivated ? REACTIVATE_MEMBER_MESSAGE : null,
    fail: isDeactivated ? REACTIVATE_MEMBER_FAIL : DEACTIVATE_MEMBER_FAIL,
    success: isDeactivated
      ? REACTIVATE_MEMBER_SUCCESS
      : DEACTIVATE_MEMBER_SUCCESS,
    title: isDeactivated ? REACTIVATE_MEMBER_TITLE : DEACTIVATE_MEMBER_TITLE
  };
};
